import { combineReducers } from "redux";

import { IDocument } from "../api";
import { RootAction } from "../types";


function selected(state: string | null = null, action: RootAction): string | null {
  switch (action.type) {
    case 'SELECT_TRANSCRIPT':
      return action.payload;
    default:
      return state;
  }
}

function data(state: {[k: string]: IDocument} = { }, action: RootAction): {[k: string]: IDocument} {
  switch (action.type) {
    case 'FETCH_TRANSCRIPT_SUCCESS':
      const {trackID} = action.meta;
      const doc = action.payload;

      // Fill in word.word, which is omitted from the transcript
      // for smaller file size
      doc.alignment.forEach(word => {
        word.word = doc.transcript.slice(word.textStart, word.textEnd);
      });

      return { 
        ...state,
        [trackID]: doc
      };

    default:
      return state;
  }
}

interface IStatus {
  error: Error | null,
  loading: boolean,
}

function status(state: {[k: string]: IStatus} = {}, action: RootAction): {[k: string]: IStatus} {
  let trackID;

  switch (action.type) {
  case 'FETCH_TRANSCRIPT_SUCCESS':
    trackID = action.meta.trackID;
    return {
      ...state,
      [trackID]: {
        error: null,
        loading: false,
      },
    };
  case 'FETCH_TRANSCRIPT_REQUEST':
    trackID = action.meta.trackID;
    return {
      ...state,
      [trackID]: {
        error: null,
        loading: true,
      },
    };
  case 'FETCH_TRANSCRIPT_FAILURE':
    trackID = action.meta.trackID;
    return {
      ...state,
      [trackID]: {
        error: action.payload,
        loading: false,
      },
    };
  default:
    return state;
  }
}

export const transcriptsReducer = combineReducers({
  data,
  selected,
  status,
});
export default transcriptsReducer;



// WEBPACK FOOTER //
// ./src/reducers/transcriptsReducer.ts